import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PlayClassic from "./pages/PlayClassic";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Dictionary from "./pages/Dictionary";
import ReadFromPicture from "./pages/ReadFromPicture";
import Play from "./pages/Play";
import Rules from "./pages/Rules";
import Training from "./pages/Training";
import Play960 from "./pages/Play960";

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/play">
          <Play />
        </Route>
        <Route path="/play-classic">
          <PlayClassic />
        </Route>
        <Route path="/play-960">
          <Play960 />
        </Route>
        <Route path="/read-from-picture">
          <ReadFromPicture />
        </Route>
        <Route path="/dictionary">
          <Dictionary />
        </Route>
        <Route path="/training">
          <Training />
        </Route>
        <Route path="/rules">
          <Rules />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
